import { useMemo, useRef } from "react";

export type PostHydrationLatch = {
  isDecided: () => boolean;
  /** Marks the current project load as handled, so the post-hydration decision does not run (again). */
  markDecided: () => void;
  reset: () => void;
};

/** Whether the page already acted (or chose not to) for the current project load; one shot per load. */
export const usePostHydrationLatch = (): PostHydrationLatch => {
  const decidedRef = useRef(false);
  return useMemo(
    () => ({
      isDecided: () => decidedRef.current,
      markDecided: () => {
        decidedRef.current = true;
      },
      reset: () => {
        decidedRef.current = false;
      },
    }),
    []
  );
};
